import { PayloadAction } from "@reduxjs/toolkit";
import { ICode, ICodeListViewState } from "./Types";

const defaultCode: ICode = {
  executionId: "",
  codeListId: "",
  codeListName: "",
  ruleName: "",
  artefactId: ""
};

export const Reducer = {
  setCode: (state: ICodeListViewState, action: PayloadAction<ICode>): ICodeListViewState => {
    return {
      ...state,
      codeListView: { ...action.payload }
    };
  },
  resetCode: ((state: ICodeListViewState): ICodeListViewState => {
    return {
      ...state,
      codeListView: { ...defaultCode }
    };
  })
};
